import {Injectable} from '@angular/core';
import {UsersService} from '../api/services/users.service';
import {MessagingTemplateService as ApiTemplateService} from '../api/services/messaging-template.service';
import {LookupModel, MessagingTemplateModel, TemplateListRequest, TemplateListResponse} from '../api/models';

@Injectable()
export class ProMessagingTemplateService {

  categories: LookupModel[] = [
    {text: 'Portal', id: 0 },
    {text: 'Chrome Extension', id: 1 },
  ];

  constructor(private apiUserService: UsersService,
              private apiTemplateService: ApiTemplateService,
  ) {

  }

  public async getTemplateListResponse(state: TemplateListRequest): Promise<TemplateListResponse> {
    console.log(state);
    return await this.apiTemplateService.messagingTemplateGetList({
      body: state,
    }).toPromise();
  }

  public async getTemplateById(id: string): Promise<MessagingTemplateModel> {
    return await this.apiTemplateService.messagingTemplateGetTemplateById({
      id: id,
    }).toPromise();
  }

  public async saveTemplate(model: MessagingTemplateModel): Promise<boolean> {
    await this.apiTemplateService.messagingTemplateSaveTemplate({
      body: model
    }).toPromise();

    return true;
  }

  public async deleteTemplateById(id: string): Promise<boolean> {
    await this.apiTemplateService.messagingTemplateDeleteTemplateById({
      id,
    }).toPromise();

    return true;
  }
}
